import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

import VueCookie from 'vue-cookie'
import VueResource from 'vue-resource'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VueProgressBar from 'vue-progressbar'

import scrollMonitor from 'scrollmonitor'

// local components
import FileActions from '@/components/common/FileActions'
import InViewportContainer from '@/components/common/InViewportContainer'
import NoFilesPage from '@/components/common/NoFilesPage'
import SvgImage from '@/components/common/SvgImage'

Vue.use(VueCookie)
Vue.use(VueResource)
Vue.use(Element, { locale })
Vue.use(Viewer)
Vue.use(VueProgressBar, {
  color: '#007EE5',
  failedColor: '#BC2E29',
  thickness: '3px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
})

// sentry integration
if (process.env.NODE_ENV !== 'development') {
  Raven
    .config('https://309647c6ee734b62aa2c5984358eaa5c@sentry.appunite.com/42')
    .addPlugin(RavenVue, Vue)
    .install()
}

// globals
global.scrollMonitor = scrollMonitor

// local components
Vue.component('FileActions', FileActions)
Vue.component('InViewportContainer', InViewportContainer)
Vue.component('NoFilesPage', NoFilesPage)
Vue.component('SvgImage', SvgImage)

Vue.config.productionTip = false

Vue.http.interceptors.push((request, next) => {
  next((response) => {
    if (!response.ok && response.status === 401) {
      store.dispatch('user/logout', false)
    }
  })
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
